<div class="not-found">
    <div class="not-found__box">
    <h1>404</h1>
    <p>The page you were looking for either not available or removed.</p>
    <button class="btn btn--primary" [routerLink]="['/login']">Go To Home</button>
</div>
</div>